module.exports = __webpack_public_path__ + "static/media/teygja_armretta_small.adeff31b.png";